import { Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { ForfaitAuditeurDetail } from "..";
import { ForfaitAuditeurApi } from "../../../../api";
import { ERoutes } from "../../../../AppRouter";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";

export interface IForfaitAuditeurPageProps {}

export const ForfaitAuditeurPage: React.FunctionComponent<IForfaitAuditeurPageProps> = () => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const history = useHistory();

  const Api = useApiService(ForfaitAuditeurApi);
  const [displayName] = useApiEffect(() => Api.forfaitAuditeurGetDisplayName({ id: +id }), [id]);

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.ForfaitAuditeur), route: ERoutes.forfaitAuditeur },
        { text: +id <= 0 ? t(ETLCodes.New) : displayName }
      ]}
    >
      <ProtectedTabs
        id="TabsUniteActivite"
        onChange={newTabId => history.push(`${ERoutes.forfaitAuditeur}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.forfaitAuditeur}></BackButton>
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<ForfaitAuditeurDetail idForfait={+id} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
